module.exports = __webpack_public_path__ + "static/cheat-codes-d19ed465f71213fc5a0ec4b39c61a56e.svg";